import z from 'zod';

export const attachmentTypeSchema = z.enum([
  'image/jpeg',
  'image/png',
  'image/gif',
  'video',
  'audio',
  'document',
]);

export const attachmentBlobSchema = z
  .array(
    z.object({
      type: z.string().min(1),
      content: z.string(),
    }),
  )
  .optional()
  .describe(
    'Attachments that comes fromt the UI. We need to parse it to store it in disk or some place else...',
  );

export type AttachmentBlob = z.infer<typeof attachmentBlobSchema>;

export type AttachmentType = z.infer<typeof attachmentTypeSchema>;

export const attachmentUrlSchema = z
  .array(
    z.object({
      type: z.string().optional(),
      fileId: z.string(),
    }),
  )
  .describe(
    'Files that are in our server or 3rd party services like AWS S3, Google Drive, etc.',
  );

export type AttachmentUrl = z.infer<typeof attachmentUrlSchema>;
